import React, { useContext } from "react";

import { DialogContext } from "../context/DialogContext";
import arrowDownThinIcon from "./../assets/images/arrow-down-thin.svg";
import Button, { ButtonSize } from "./Buttons/Button";

interface Props {
  title: string;
}

export const MarketSelectorButton = (props: Props) => {
  const context = useContext(DialogContext);

  return (
    <>
      <Button
        type="button"
        size={ButtonSize.Small}
        color="primary-transparent"
        onClick={() => context.dispatch({ type: "marketSelector.open" })}
      >
        <span className="inline-block mr-10 text-center">{props.title}</span>
        <span className="absolute top-0 right-0 flex justify-center items-center w-12 h-full p-3 border-neutral-100 border-l">
          <svg width={18} height={12} className="stroke-current">
            <use xlinkHref={arrowDownThinIcon.url} />
          </svg>
        </span>
      </Button>
    </>
  );
};

